<div class="scheduled-events">
  <div class="header">
    <h2>Scheduled Events</h2>
    <button mat-raised-button color="primary" (click)="createEvent()">
      <mat-icon>add</mat-icon>
      Create Event
    </button>
  </div>

  <div class="content" [class.loading]="loading">
    <mat-spinner *ngIf="loading" diameter="50"></mat-spinner>

    <div *ngIf="!loading && events.length === 0" class="no-events">
      <mat-icon>event_note</mat-icon>
      <h3>No scheduled events</h3>
      <p>Create your first scheduled event to automate tasks like backups, exports, and reports.</p>
      <button mat-raised-button color="primary" (click)="createEvent()">
        Create Event
      </button>
    </div>

    <div *ngIf="!loading && events.length > 0" class="events-grid">
      <mat-card *ngFor="let event of events" class="event-card">
        <mat-card-header>
          <div mat-card-avatar class="event-avatar" [style.background-color]="getStatusColor(event.status)">
            <mat-icon>{{ event.isActive ? 'schedule' : 'schedule_off' }}</mat-icon>
          </div>
          <mat-card-title>{{ event.name }}</mat-card-title>
          <mat-card-subtitle>{{ getEventTypeLabel(event.eventType) }}</mat-card-subtitle>
          <div class="card-actions">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editEvent(event)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="runEventNow(event)">
                <mat-icon>play_arrow</mat-icon>
                <span>Run Now</span>
              </button>
              <button mat-menu-item (click)="toggleEvent(event)">
                <mat-icon>{{ event.isActive ? 'pause' : 'play_arrow' }}</mat-icon>
                <span>{{ event.isActive ? 'Deactivate' : 'Activate' }}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="deleteEvent(event)" class="delete-option">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </mat-card-header>

        <mat-card-content>
          <div class="event-description">
            {{ event.description }}
          </div>

          <div class="event-details">
            <div class="detail-row">
              <span class="label">Schedule:</span>
              <span class="value">{{ getCronDescription(event.cronExpression) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Timezone:</span>
              <span class="value">{{ event.timezone }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Last Run:</span>
              <span class="value">{{ formatDate(event.lastRun) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Next Run:</span>
              <span class="value">{{ formatDate(event.nextRun) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Executions:</span>
              <span class="value">{{ event.executionCount }}</span>
            </div>
          </div>

          <div class="status-section">
            <mat-chip-list>
              <mat-chip [style.background-color]="getStatusColor(event.status)"
                       [style.color]="'white'">
                {{ event.status | titlecase }}
              </mat-chip>
              <mat-chip *ngIf="!event.isActive" color="warn" selected>
                Inactive
              </mat-chip>
            </mat-chip-list>
          </div>

          <div *ngIf="event.lastError" class="error-section">
            <mat-icon color="warn">error</mat-icon>
            <span class="error-text">{{ event.lastError }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
